/* MAG ARTICLE - Lesefortschritt, Inhaltsverzeichnis (Desktop-Rail + Mobile),
   Teilen, Aufräumen von Alt-Inhalten. Alles Progressive Enhancement. */

(function () {
  const root = document.querySelector('[data-mag-article]');
  if (!root) return;
  const body = root.querySelector('[data-article-body]');

  /* ---------- 1) Genau ein Hero pro Artikel ----------
     Bestandsartikel speichern das Beitragsbild teils als IMG, in einem Wrapper
     oder als CSS-Hintergrund ein zweites Mal. Zusätzlich können zwei Uploads
     desselben Motivs unterschiedliche CDN-Adressen besitzen. Deshalb gilt die
     redaktionelle Strukturregel: Der Template-Hero ist das einzige Bild vor
     dem ersten substanziellen Textabsatz. Spätere Inhaltsbilder bleiben. */
  const hero = root.querySelector('[data-article-hero] img');
  if (hero && body) {
    const canonical = (value) => {
      try {
        const url = new URL(value || '', document.baseURI);
        return decodeURIComponent(url.pathname)
          .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '')
          .toLowerCase();
      } catch (error) {
        return (value || '').split('?')[0].toLowerCase();
      }
    };
    const sourcesFor = (image) => [
      image.currentSrc,
      image.src,
      image.getAttribute('src'),
      image.getAttribute('data-src'),
      ...(image.getAttribute('srcset') || '').split(',').map((part) => part.trim().split(' ')[0])
    ].filter(Boolean).map(canonical);
    const heroSources = sourcesFor(hero);
    const heroFiles = heroSources.map((source) => source.split('/').pop());
    const markMedia = (media) => {
      if (!media || media.closest('.is-duplicate-hero-media')) return;
      let wrap = media;
      const candidates = [media.closest('figure'), media.closest('picture'), media.closest('p'), media.closest('a'), media.closest('div')];
      const tight = candidates.find((candidate) =>
        candidate && body.contains(candidate) &&
        candidate.querySelectorAll('img, picture, video').length <= 1 &&
        candidate.textContent.replace(/[\s\u200b]/g, '').length < 120
      );
      if (tight) wrap = tight;
      wrap.classList.add('is-duplicate-hero-media');
      wrap.setAttribute('aria-hidden', 'true');
    };

    body.querySelectorAll('img').forEach((image) => {
      const bodySources = sourcesFor(image);
      const bodyFiles = bodySources.map((source) => source.split('/').pop());
      const sameSource = heroSources.some((source) => bodySources.includes(source));
      const sameFile = heroFiles.some((file) => bodyFiles.includes(file));
      const sameAlt = hero.alt && image.alt && hero.alt.trim().toLowerCase() === image.alt.trim().toLowerCase();
      if (sameSource || sameFile || sameAlt) markMedia(image);
    });

    body.querySelectorAll('[style]').forEach((element) => {
      const match = getComputedStyle(element).backgroundImage.match(/url\(["']?([^"')]+)/i);
      if (match && heroSources.includes(canonical(match[1]))) markMedia(element);
    });

    const title = root.querySelector('.mag-article__title')?.textContent.trim() || '';
    if (!/^the\.(?:drop|noise)\b/i.test(title)) {
      const firstMeaningful = Array.from(body.children).find((element) => {
        if (['STYLE', 'SCRIPT'].includes(element.tagName) || element.classList.contains('is-duplicate-hero-media')) return false;
        const text = element.textContent.replace(/[\s\u200b]/g, '');
        return text.length > 0 || element.matches('img, picture, figure, video') || element.querySelector('img, picture, video') || getComputedStyle(element).backgroundImage !== 'none';
      });
      if (firstMeaningful) {
        const textLength = firstMeaningful.textContent.replace(/[\s\u200b]/g, '').length;
        const hasMedia = firstMeaningful.matches('img, picture, figure, video') ||
          firstMeaningful.querySelector('img, picture, video') ||
          getComputedStyle(firstMeaningful).backgroundImage !== 'none';
        if (hasMedia && textLength < 120) markMedia(firstMeaningful);
      }
    }
  }

  /* ---------- 1b) Doppelte Lede: wenn der Body mit demselben Text beginnt,
     Lede im Kopf ausblenden (Excerpt war nur der erste Absatz) ---------- */
  const lede = root.querySelector('.mag-article__lede');
  const firstP = body ? Array.from(body.querySelectorAll('p')).find((paragraph) =>
    !paragraph.closest('.is-duplicate-hero-media') && paragraph.textContent.replace(/\s+/g, ' ').trim().length > 40
  ) : null;
  if (lede && firstP) {
    const norm = (t) => (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
    const l = norm(lede.textContent).replace(/[….]+$/, '');
    const p = norm(firstP.textContent);
    if (l.length > 40 && (p.startsWith(l) || l.startsWith(p.slice(0, l.length)))) {
      /* Bis zum 05.08.2026 verschwand hier immer der Vorspann. Ergebnis: der
         Einstieg lief als gewöhnlicher Serifenabsatz mit, der Kopf hatte
         keinen, und hundert Pixel weiter stand fast derselbe Satz noch einmal
         als Rezept-Dek. Der Kopf gewinnt jetzt - es sei denn, der Vorspann ist
         eine gekürzte Fassung des Absatzes. Dann würde Text verloren gehen,
         und der Absatz bleibt. */
      const truncated = p.startsWith(l) && p.length > l.length + 20;
      if (truncated) {
        lede.style.display = 'none';
      } else {
        firstP.classList.add('is-duplicate-lede');
        firstP.setAttribute('aria-hidden', 'true');
        firstP.style.display = 'none';
      }
    }
  }

  /* ---------- 1c) Alte Body-Module in das Magazinsystem überführen ----------
     Viele Bestandsartikel enthalten eigene Inline-Styles und Unicode-Symbole.
     Hier bekommen sie nur semantische Klassen; die Darstellung bleibt in CSS. */
  if (body) {
    const structuredRecipe = root.querySelector('mag-recipe');
    if (structuredRecipe) {
      const legacyRecipe = body.querySelector('#rezept');
      if (legacyRecipe) legacyRecipe.removeAttribute('id');
      structuredRecipe.id = 'rezept';

      /* Das Rezept steht direkt hinter dem Einstieg.

         Bis zum 05.08.2026 stand hier body.append(). Das Modul landete am
         Ende des Textes: 3.912px in eine Seite von 13.487px, also nach
         29 Prozent und nach rund 500 Wörtern Vorlauf. Difford's, Kitchen
         Stories und BBC Good Food setzen es zwischen 735 und 1.536px.

         Der erste Versuch hat das per CSS order gelöst - falsch. Dann
         stimmt das Bild, aber Tabulatorreihenfolge, Screenreader und
         Inhaltsverzeichnis laufen auseinander: gemessen ein Tabsprung von
         4.139px zurück und 3.005px vorwärts. WCAG 2.2 SC 1.3.2 und
         SC 2.4.3, beide Level A. Also wird im Dokument verschoben. */
      /* Seit 06.08.2026 setzt sections/mag-article.liquid das Modul schon
         serverseitig hinter den ersten Absatz - damit auch Crawler ohne
         JavaScript das Rezept oben finden. Steht es dort bereits, gibt es
         hier nichts mehr zu verschieben. */
      const alreadyPlaced = body.contains(structuredRecipe) &&
        Array.from(body.children).indexOf(structuredRecipe) <= 3;

      let anchor = alreadyPlaced ? structuredRecipe : null;
      if (!alreadyPlaced) for (const element of Array.from(body.children)) {
        if (element === structuredRecipe) break;
        if (['STYLE', 'SCRIPT'].includes(element.tagName)) { anchor = element; continue; }
        if (element.classList.contains('is-duplicate-hero-media') ||
          element.classList.contains('is-duplicate-lede')) { anchor = element; continue; }
        if (element.tagName === 'P' &&
          element.textContent.replace(/\s+/g, ' ').trim().length > 60) {
          anchor = element;
          /* Ein Bild direkt hinter dem Einstieg gehört noch zum Einstieg. */
          const next = element.nextElementSibling;
          if (next && next.tagName === 'FIGURE') anchor = next;
          break;
        }
        /* Überschrift, Liste, Kasten - hier fängt der Text an. */
        break;
      }
      if (!alreadyPlaced) {
        if (anchor && !anchor.contains(structuredRecipe)) {
          anchor.after(structuredRecipe);
        } else {
          body.prepend(structuredRecipe);
        }
      }

      /* Wenn das Rezept oben steht, führt "Direkt zum Rezept" nach hinten.
         Der Knopf hat dann keine Aufgabe mehr. */
      body.querySelectorAll('.jump-to-recipe, a[href="#rezept"]').forEach((jump) => {
        if (jump.closest('mag-recipe')) return;
        const where = structuredRecipe.compareDocumentPosition(jump);
        if (where & Node.DOCUMENT_POSITION_FOLLOWING) jump.remove();
      });
    }

    /* Historische Autorenboxen im Artikel-HTML sind uneinheitlich und führen
       zu Doppelungen. Profile kommen ausschließlich aus mag-author-box. */
    body.querySelectorAll('.author-box').forEach((legacyAuthor) => legacyAuthor.remove());

    Array.from(body.children).forEach((element) => {
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (element.tagName === 'DIV' && text.includes('Marie mixt auch Cocktails')) {
        element.removeAttribute('style');
        element.classList.add('mag-article__callout');
        element.querySelectorAll('[style]').forEach((child) => child.removeAttribute('style'));
      }
    });

    /* Historische Artikel und Kollektionen wurden verschoben. Die Inhalte
       bleiben im Admin unangetastet; im Store zeigen ihre Links auf die heute
       kanonischen, im Sitemap vorhandenen Ziele. */
    const legacyHrefMap = {
      '/blogs/rezepte/colorado-bulldog-mit-schwarzes-gold-kaffeelikor': '/blogs/rezepte/colorado-bulldog-longdrink-eine-erfrischende-variante-mit-schwarzes-gold-espresso-likor',
      '/blogs/rezepte/cafe-sour-cocktail-ein-erfrischender-cocktail-mit-schwarzes-gold-espressolikor': '/blogs/rezepte/cafe-sour-cocktail-ein-erfrischender-cocktail-mit-schwarzes-gold-espresso-likor',
      '/blogs/rezepte/schokoladen-cantuccini-mit-schwarzem-gold': '/blogs/kitchen/schokoladen-cantuccini-mit-schwarzem-gold',
      '/blogs/rezepte/vigamisu-veganes-tiramisu-mit-schwarzes-gold-kaffeelikor': '/blogs/kitchen/vigamisu-veganes-tiramisu-mit-schwarzes-gold-kaffeelikor',
      '/blogs/rezepte/delicatobollar-schwedische-schoko-schnee-kugeln-vegan-und-glutenfrei': '/blogs/kitchen/delicatobollar-schwedische-schoko-schnee-kugeln-vegan-und-glutenfrei',
      '/blogs/rezepte/bananenbrot-mit-walnussen-und-schokolade-vegan': '/blogs/kitchen/bananenbrot-mit-walnussen-und-schokolade-vegan',
      '/collections/as-if-records-white-russian-kollektion': '/collections/liquid-joy',
      '/collections/as-if-records-black-russian-kollektion': '/collections/liquid-joy',
      '/collections/as-if-records-coldbrew-negroni-kollektion': '/collections/liquid-joy',
      '/collections/as-if-records-espresso-martini-kollektion': '/collections/liquid-joy'
    };
    body.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.getAttribute('href'), document.baseURI);
        const replacement = legacyHrefMap[url.pathname];
        if (replacement && url.origin === location.origin) link.setAttribute('href', replacement + url.hash);
      } catch (error) { /* ungültige Alt-URL unverändert lassen */ }
    });

    if (location.pathname.includes('/blogs/schwarzes-gold-kaffeelikor/')) {
      body.classList.add('mag-article__prose--gold-series');
      Array.from(body.children).forEach((element) => {
        const inline = (element.getAttribute('style') || '').toLowerCase();
        if (inline.includes('grid-template-columns') && inline.includes('repeat(3')) {
          element.classList.add('mag-legacy-card-grid');
        }
        if (inline.includes('#2a9d8f') || inline.includes('42, 157, 143')) {
          element.removeAttribute('style');
          element.classList.add('mag-article__callout');
          element.querySelectorAll('[style]').forEach((child) => child.removeAttribute('style'));
        }
      });
      body.querySelectorAll('[style]').forEach((element) => {
        const style = element.style;
        const important = (property, value) => style.setProperty(property, value, 'important');
        const color = style.getPropertyValue('color').replace(/\s+/g, '').toLowerCase();
        const background = style.getPropertyValue('background').replace(/\s+/g, '').toLowerCase();
        if (color === '#2a9d8f' || color === 'rgb(42,157,143)') important('color', 'var(--mag-ink)');
        if (background.includes('#2a9d8f') || background.includes('42,157,143')) important('background', 'var(--mag-signal)');
        if (style.getPropertyValue('border-radius')) important('border-radius', '0');
      });
    }

    body.querySelectorAll('a').forEach((link) => {
      const firstNode = Array.from(link.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      if (!firstNode) return;
      const cleaned = firstNode.textContent.replace(/^\s*[\u2192\u2197\u2198\u279c\u279d]\s*/, '');
      if (cleaned !== firstNode.textContent) {
        firstNode.textContent = cleaned;
        link.classList.add('mag-legacy-arrow-link');
      }
    });

    body.querySelectorAll('h2, h3').forEach((heading) => {
      if (!/^mehr von\b/i.test(heading.textContent.trim())) return;
      const links = heading.nextElementSibling;
      if (!links || !links.classList.contains('cta-links')) return;
      heading.classList.add('is-legacy-related-duplicate');
      links.classList.add('is-legacy-related-duplicate');
      heading.setAttribute('aria-hidden', 'true');
      links.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---------- 1d) Offenlegung an der Autorenbox ----------
     Das Magazin gehört dem Laden, in den es verlinkt. Wer Produkte
     empfiehlt und sie selbst verkauft, sagt das - einmal, sachlich, an
     der Stelle, an der die Person steht. */
  const authorBox = document.querySelector('.mag-author');
  if (authorBox && !authorBox.querySelector('.mag-author__disclosure')) {
    const note = document.createElement('p');
    note.className = 'mag-author__disclosure';
    note.textContent = document.querySelector('.radio-editorial-listen')
      ? 'as.if.records betreibt dieses Magazin und as.if.radio. Die Redaktion schreibt mit KI-Unterstützung über Musik und Wege zu neuen Entdeckungen.'
      : 'as.if.records betreibt dieses Magazin und verkauft einen Teil der hier empfohlenen Produkte selbst. Rezepte und Empfehlungen entstehen trotzdem in der eigenen Küche, nicht im Marketing.';
    authorBox.append(note);
  }

  /* ---------- 2) Lesefortschritt ---------- */
  const bar = root.querySelector('[data-progress]');
  if (bar && body) {
    let ticking = false;
    const update = () => {
      const rect = body.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (done / total) * 100 : 0) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- 3) Inhaltsverzeichnis aus H2s ----------
     Die Überschrift im Rezeptmodul ist der Rezeptname, kein Abschnitt.
     Solange sie mitgezählt wurde, stand im Verzeichnis ein Eintrag, der
     nirgendwo hinführte, wo man ihn erwartet hätte. */
  const tocDesk = root.querySelector('[data-toc]');
  const tocMob = root.querySelector('[data-toc-mobile]');
  if (body && (tocDesk || tocMob)) {
    const heads = Array.from(body.querySelectorAll('h2')).filter((h) =>
      h.innerText.trim().length > 1 &&
      !h.classList.contains('is-legacy-related-duplicate') &&
      !h.closest('mag-recipe') &&
      !h.closest('.recipe-card')
    );
    /* Ein Inhaltsverzeichnis lohnt ab fünf Abschnitten. Darunter ist es
       ein Bedienelement, das den Einstieg verzögert, ohne zu helfen. */
    if (heads.length >= 5) {
      const items = heads.map((h, i) => {
        if (!h.id) h.id = 'abschnitt-' + (i + 1);
        return { id: h.id, text: h.innerText.trim() };
      });
      const fill = (list) => {
        if (!list) return;
        list.innerHTML = items.map((it) =>
          `<li><a href="#${it.id}" data-toc-link="${it.id}">${it.text.replace(/</g, '&lt;')}</a></li>`
        ).join('');
      };
      fill(root.querySelector('[data-toc-list]'));
      fill(root.querySelector('[data-toc-list-mobile]'));
      if (tocDesk) tocDesk.hidden = false;
      if (tocMob) tocMob.hidden = false;

      // Scrollspy (nur Desktop-Rail)
      if ('IntersectionObserver' in window && tocDesk) {
        const links = tocDesk.querySelectorAll('[data-toc-link]');
        const byId = {};
        links.forEach((l) => { byId[l.dataset.tocLink] = l; });
        let current = null;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              if (current) current.removeAttribute('aria-current');
              current = byId[e.target.id];
              if (current) current.setAttribute('aria-current', 'true');
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach((h) => io.observe(h));
      }

      // Mobile: nach Klick zuklappen
      if (tocMob) {
        tocMob.querySelectorAll('a').forEach((a) => {
          a.addEventListener('click', () => { tocMob.open = false; });
        });
      }
    }
  }

  /* ---------- 4) Teilen ---------- */
  const nativeBtn = root.querySelector('[data-share-native]');
  const copyBtn = root.querySelector('[data-share-copy]');
  /* Ein Knopf, nicht zwei. Wo das Gerät ein eigenes Teilen-Blatt hat,
     steckt die Zwischenablage darin; wo nicht, bleibt der Link-Knopf.
     Das hidden-Attribut statt eines Inline-Styles, weil mag-article.css
     die Anzeige mit !important setzt und ein Inline-Style dagegen
     verliert - gemessen am 05.08.2026: beide Knöpfe sichtbar. */
  if (nativeBtn) {
    if (navigator.share) {
      nativeBtn.addEventListener('click', () => {
        navigator.share({ title: document.title, url: location.href }).catch(() => {});
      });
      if (copyBtn) copyBtn.hidden = true;
    } else {
      nativeBtn.hidden = true;
    }
  }
  if (copyBtn) {
    /* Die sichtbare Rueckmeldung "Kopiert" bekommt eine Live-Region, sonst
       passiert fuer eine Hilfstechnik gar nichts (SC 4.1.3). Der zugaengliche
       Name des Knopfes bleibt konstant bei "Link kopieren", damit sichtbarer
       Text und Name nicht auseinanderlaufen (SC 2.5.3). */
    let copyLive = copyBtn.parentElement
      && copyBtn.parentElement.querySelector('[data-copy-live]');
    if (!copyLive && copyBtn.parentElement) {
      copyLive = document.createElement('p');
      copyLive.className = 'asif-sr-live';
      copyLive.setAttribute('role', 'status');
      copyLive.setAttribute('aria-live', 'polite');
      copyLive.setAttribute('data-copy-live', '');
      copyBtn.parentElement.appendChild(copyLive);
    }
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(location.href);
        if (copyLive) copyLive.textContent = 'Link in die Zwischenablage kopiert.';
        const label = copyBtn.querySelector('[data-copy-label]');
        if (label) {
          const prev = label.textContent;
          label.textContent = 'Kopiert';
          setTimeout(() => { label.textContent = prev; }, 1600);
        }
      } catch (e) {
        if (copyLive) copyLive.textContent = 'Der Link konnte nicht kopiert werden.';
      }
    });
  }

  /* ---------- 4b) Sprungziele nicht unter die Kopfleiste schieben ----------
     scroll-padding-top stand fest auf 88px, die klebende Kopfleiste misst
     auf dem Telefon 118px. Wer im Inhaltsverzeichnis auf einen Abschnitt
     tippt, landete unter der Leiste. Der Wert kommt jetzt aus der Messung
     und wird bei Groessenaenderung nachgezogen. */
  const stickyTop = () => {
    let height = 0;
    document.querySelectorAll('header, .header, [class*="header"], .announcement-bar').forEach((el) => {
      const style = getComputedStyle(el);
      if (style.position !== 'sticky' && style.position !== 'fixed') return;
      if (el.offsetHeight < 8) return;
      /* Am Anfang der Seite steht die klebende Leiste noch unter der
         Ankündigung, ihr getBoundingClientRect().top ist dann 36 oder 41
         statt 0. Wer auf top <= 4 prüft, misst genau dort nie - und fiel
         auf einen festen Wert von 88px zurück. Maßgeblich ist, wo sie
         hängen bleibt: der eigene top-Offset plus die eigene Höhe. */
      const offset = parseFloat(style.top);
      height = Math.max(height, (Number.isFinite(offset) ? Math.max(offset, 0) : 0) + el.offsetHeight);
    });
    /* scroll-margin-top an den Überschriften zählt sonst ein zweites Mal. */
    document.documentElement.style.setProperty('--asif-anchor-offset', '0px');
    document.documentElement.style.scrollPaddingTop = (height ? height + 16 : 88) + 'px';
  };
  stickyTop();
  window.addEventListener('resize', stickyTop, { passive: true });

  /* ---------- 5) Doppeltes Recipe-JSON-LD aus Alt-Bodies entfernen ----------
     Der Block, den mag-recipe.js übernommen und ergänzt hat, trägt eine
     Markierung und bleibt. Alles Weitere ist eine Dublette. */
  if (document.querySelector('mag-recipe')) {
    body && body.querySelectorAll('script[type="application/ld+json"]').forEach((s) => {
      if (s.dataset.magRecipeJson) return;
      try {
        if (JSON.parse(s.textContent)['@type'] === 'Recipe') s.remove();
      } catch (e) { /* ignorieren */ }
    });
  }
})();
